<div class="lpa-main-menu">
  <div class="menu-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="pi pi-home"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Plataforma de Administración</h1>
        <p class="page-subtitle">Liga de Patinaje de Antioquia</p>
        <p class="page-description">Selecciona el módulo que deseas administrar</p>
      </div>
    </div>
  </div>
  
  <div class="menu-grid">
    <div 
      class="menu-card" 
      [routerLink]="option.routerLink" 
      *ngFor="let option of menuRol"
      [attr.data-title]="option.title"
    >
      <div class="card-icon">
        <i [class]="option.class.replace('text-4xl text-green-500', '')"></i>
      </div>
      <div class="card-content">
        <h3 class="card-title">{{ option.title }}</h3>
        <p class="card-description">{{ option.description }}</p>
      </div>
      <div class="card-arrow">
        <i class="pi pi-arrow-right"></i>
      </div>
    </div>
  </div>
</div>